<template>
    <main-dialog
        ref="dialog"
        :translated-header="toSentenceCase($t(`${PRICE_TAGS_I18N_BASE}.previewHeader`))"
        :has-activator="false"
        :show-positive-action-button="false"
        :persistent="false"
        width="640"
    >
        <div class="price-tag-preview">
            <price-tag-renderer
                :layout="priceTag.layout"
                :values="values"
                :fields-by-key="fieldsByKey"
                :context="context"
            />
        </div>
    </main-dialog>
</template>

<script setup>
import { computed, ref } from 'vue';
import { toSentenceCase } from '@/js/utils/string-utils';
import { PRICE_TAGS_I18N_BASE } from '@/js/composables/usePriceTagText';
import { readValuesFromMechanic } from '@/js/utils/price-tags/binding-engine';
import { buildPriceTagContext } from '@/js/utils/price-tags/price-tag-context';
import { DEFAULT_PRICE_TAG } from '@/js/utils/price-tags/price-tag-presets';
import { keyFields } from '@/js/utils/price-tags/validate-values';

const props = defineProps({
    preset: { type: Object, default: null },
    offerMechanic: { type: Object, required: true },
    displayValues: { type: Object, default: () => ({}) },
    contextSource: { type: Object, required: true },
});

const dialog = ref(null);
const priceTag = computed(() => (props.preset ? props.preset.priceTag : DEFAULT_PRICE_TAG));
const fieldsByKey = computed(() => keyFields(priceTag.value.fields));
const values = computed(() =>
    readValuesFromMechanic({
        offerMechanic: props.offerMechanic,
        fields: priceTag.value.fields,
        displayValues: props.displayValues,
        transformContext: props.contextSource.transformContext,
    })
);
const context = computed(() =>
    buildPriceTagContext({
        ...props.contextSource,
        offerMechanic: props.offerMechanic,
        displayValues: props.displayValues,
        useStoredPrices: true,
    })
);
const open = () => dialog.value.open();

defineExpose({ open });
</script>

<style lang="scss" scoped>
.price-tag-preview {
    display: flex;
    justify-content: center;
    padding: 1.6rem 0;
}
</style>
